import React from "react";
import { FeatureProps } from "./interfaces/Feature";
import Button from "../primitives/Button";
import Text from "../Common/Text";
import Image from "../Common/Image";

const DEFAULTDATA: FeatureProps = {
  image: {
    desktop:
      "https://assets.dogtorsoftware.com/25/website/d47ed3ae-41df-4bcb-a728-5d03187d94e3.png",
  },
  title: { value: "¡Explora la innovación con Dogtorsoftware!" },
  button: { name: "Conoce más" },
};

const Feature = ({
  data = DEFAULTDATA,
  onChange,
}: {
  data: FeatureProps;
  onChange?: (value: any, id?: string) => void;
}) => {
  return (
    <div>
      <div className="bg-white py-10">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2 flex-col-reverse">
            <div
              className={`lg:pr-8 lg:pt-4 ${
                data?.alling === "RIGHT" ? "order-2" : "order-1"
              }`}
            >
              <div className="lg:max-w-lg">
                <Text
                  editor={!!onChange}
                  id="Feature"
                  onChange={(val: any) => onChange?.(val, "title")}
                >
                  {data?.title}
                </Text>
                <Button {...data?.button} className="mt-5" />
              </div>
            </div>
            <div
              className={`${data?.alling === "RIGHT" ? "order-1" : "order-2"}`}
            >
              {data?.image?.desktop && (
                <Image
                  {...data.image}
                  className="rounded-xl shadow-xl ring-1 ring-gray-400/10 w-full"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feature;
